module.exports = "/_next/static/images/7948aa7880d623910352bb3f3601ed0f-cards-right-small.jpg.webp";